/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaUiAPlayIcon16Light } from './MediaUiAPlayIcon16Light';
import { MediaUiAPlayIcon16Regular } from './MediaUiAPlayIcon16Regular';
import { MediaUiAPlayIcon16Solid } from './MediaUiAPlayIcon16Solid';
import { MediaUiAPlayIcon20Light } from './MediaUiAPlayIcon20Light';
import { MediaUiAPlayIcon20Regular } from './MediaUiAPlayIcon20Regular';
import { MediaUiAPlayIcon20Solid } from './MediaUiAPlayIcon20Solid';
import { MediaUiAPlayIcon24Regular } from './MediaUiAPlayIcon24Regular';
import { MediaUiAPlayIcon24Solid } from './MediaUiAPlayIcon24Solid';
import { MediaUiAPlayIcon32Regular } from './MediaUiAPlayIcon32Regular';
import { MediaUiAPlayIcon64Regular } from './MediaUiAPlayIcon64Regular';
var sizes = {
    16: {
        light: MediaUiAPlayIcon16Light,
        regular: MediaUiAPlayIcon16Regular,
        solid: MediaUiAPlayIcon16Solid,
    },
    20: {
        light: MediaUiAPlayIcon20Light,
        regular: MediaUiAPlayIcon20Regular,
        solid: MediaUiAPlayIcon20Solid,
    },
    24: {
        regular: MediaUiAPlayIcon24Regular,
        solid: MediaUiAPlayIcon24Solid,
    },
    32: {
        regular: MediaUiAPlayIcon32Regular,
    },
    64: {
        regular: MediaUiAPlayIcon64Regular,
    },
};
export var MediaUiAPlayIcon = forwardRef('MediaUiAPlayIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
